import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ThemeCustomTokens {
  colorPrimary: string;
  sidebarBg: string;
  sidebarActiveBg: string;
  sidebarText: string;
}

interface ThemeState {
  customTokens: ThemeCustomTokens;
}

const initialState: ThemeState = {
  customTokens: {
    colorPrimary: '#a4193d',
    sidebarBg: '#1a1a2e',
    sidebarActiveBg: '#a4193d',
    sidebarText: '#ffffff',
  },
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeTokens: (state, action: PayloadAction<Partial<ThemeCustomTokens>>) => {
      Object.assign(state.customTokens, action.payload);
    },
    resetTheme: () => initialState,
  },
});

export const { setThemeTokens, resetTheme } = themeSlice.actions;
export default themeSlice.reducer;
